import React from 'react';
import { creators } from "../../utils/creators";
import { AiOutlineTwitter } from 'react-icons/ai';

class About extends React.Component {
  render() {
    return (
      <section id="about" className="about-sec wrapper r-wrapper">
        <div>
          <p className="sessions-sec-heading r-fs-1">About</p>
          <p className="about-sec-text">
            " We are group fellow developers trying to help other developers by
            stimulating their learning curve "
          </p>
          <div className="creators-cont">
            {creators.map((creator, idx) => (
              <div className="creator-card rm-vertical-1" key={idx}>
                <img className="creator-img" src={creator.img} alt="" />
                <p className="creator-name">{creator.name}</p>
                <div className="creator-card-details">
                  <p className="creator-role">{creator.role}</p>
                  <a
                    className="creator-role-link"
                    href={creator.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <AiOutlineTwitter />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default About;
